/* Quboom theme: product page. Liquid renders the selected variant; this keeps the page in step
   when a chip changes. Variant data comes from the JSON in sections/main-product.liquid. */
(() => {
  const page = document.querySelector("[data-product-page]");
  const dataEl = document.querySelector("[data-product-json]");
  if (!page || !dataEl) return;
  // Liquid's t filter and escape leave HTML entities (we&#39;ll); decode once, since text goes in via textContent.
  const unescape = s => { const t = document.createElement("textarea"); t.innerHTML = s; return t.value; };
  const P = JSON.parse(dataEl.textContent, (k, v) => (typeof v === "string" && v.includes("&") ? unescape(v) : v));
  const S = P.strings;
  const $ = (s, root = page) => root.querySelector(s);
  const $$ = (s, root = page) => [...root.querySelectorAll(s)];
  const form = $("[data-product-form]");
  const money = cents => (window.theme && window.theme.money ? window.theme.money(cents) : "$" + (cents / 100).toFixed(2));
  const fill = (str, key, val) => str.replace(`[${key}]`, val);

  // ---------- Lead time: "By sea: 50–60" lines, matched loosely like snippets/lead-time.liquid ----------
  const LEAD = (P.lead || "").split(/\r?\n/).map(line => {
    const i = line.indexOf(":");
    if (i < 0) return null;
    const [a, b] = line.slice(i + 1).replace(/[—–]/g, "-").split("-").map(n => parseInt(n, 10));
    return a ? { label: line.slice(0, i).trim().toLowerCase(), low: a, high: b || a } : null;
  }).filter(Boolean);
  const leadFor = value => {
    const want = (value || "").trim().toLowerCase();
    const hits = LEAD.filter(l => !want || l.label.includes(want) || want.includes(l.label));
    if (!hits.length) return null;
    return { low: Math.min(...hits.map(h => h.low)), high: Math.max(...hits.map(h => h.high)) };
  };
  const daysText = d => (d.high > d.low ? `${d.low}–${d.high}` : `${d.low}`);
  const dateIn = n => new Date(Date.now() + n * 864e5).toLocaleDateString("en-US", { month: "short", day: "numeric" });
  const arrival = d => `${dateIn(d.low)} – ${dateIn(d.high)}`;

  // "value: text" lines, first match wins (product lines come first)
  const note = (lines, value) => {
    const want = (value || "").trim().toLowerCase();
    for (const line of lines || []) {
      const i = line.indexOf(":");
      if (i > 0 && line.slice(0, i).trim().toLowerCase() === want) return line.slice(i + 1).trim();
    }
    return "";
  };

  // ---------- Variant from the chips ----------
  const selected = () => {
    const opts = [];
    $$("[data-option]:checked", form).forEach(i => { opts[+i.dataset.option] = i.value; });
    return opts;
  };
  const find = opts => P.variants.find(v => v.options.every((o, i) => opts[i] === undefined || o === opts[i]));

  // Buttons keep their "Added" confirmation; the label they return to follows the variant
  const setButton = (btn, text, disabled) => {
    if (!btn) return;
    btn.dataset.label = text;
    if (!btn.classList.contains("is-added")) btn.textContent = text;
    btn.disabled = disabled;
  };

  function showMedia(id) {
    const imgs = $$("[data-media]");
    if (!imgs.some(img => +img.dataset.media === id)) return;
    imgs.forEach(img => {
      const on = +img.dataset.media === id;
      img.hidden = !on;
      if (on) img.removeAttribute("loading");
    });
    $$("[data-thumb]").forEach(b => b.setAttribute("aria-current", +b.dataset.thumb === id));
  }

  let relatedReq = 0;
  async function refreshRelated(v) {
    const rel = document.querySelector("[data-related-section]");
    if (!rel) return;
    const req = ++relatedReq;
    try {
      const url = `${page.dataset.url}?variant=${v.id}&section_id=${rel.dataset.relatedSection}`;
      const html = await (await fetch(url)).text();
      if (req !== relatedReq) return;
      const next = new DOMParser().parseFromString(html, "text/html").querySelector("[data-related-section]");
      if (next) rel.innerHTML = next.innerHTML;
    } catch (e) { /* keep the cards already shown */ }
  }

  function update(v, first) {
    if (!v) return;
    const opts = v.options;

    if (!first) {
      const id = $("[data-variant-id]", form);
      id.value = v.id;
      // Shopify's payment terms and payment button listen for the id changing
      id.dispatchEvent(new Event("change", { bubbles: true }));
      const url = new URL(location.href);
      url.searchParams.set("variant", v.id);
      history.replaceState(history.state, "", url);

      const price = $("[data-price]");
      price.textContent = money(v.price);
      price.classList.toggle("is-sale", v.compare > v.price);
      $("[data-compare]").textContent = v.compare > v.price ? money(v.compare) : "";
      if (v.media) showMedia(v.media);

      // Sold out beats a saving, a saving beats the merchandising flag. Pre-order keeps its badge.
      const flag = $("[data-flag]");
      if (flag) {
        const out = !v.available;
        flag.textContent = out ? S.soldOut
          : v.compare > v.price ? fill(S.save, "percent", Math.round((1 - v.price / v.compare) * 100))
          : P.baseFlag || "";
        flag.classList.toggle("tape--grey", out);
        flag.classList.toggle("tape--ink", !out);
        flag.hidden = !flag.textContent;
      }

      const spec = $("[data-spec]");
      spec.textContent = v.spec;
      spec.hidden = !v.spec;
      ["width", "len", "rolls"].forEach(k => {
        const cell = $(`[data-fact="${k}"]`);
        if (!cell) return;
        cell.textContent = v[k];
        cell.closest("tr").hidden = !v[k];
      });

      $$("[data-picker]", form).forEach(fs => {
        const role = fs.dataset.picker, hint = $("[data-hint]", fs);
        if (!hint || role === "ship") return;
        const i = +$("[data-option]", fs).dataset.option;
        hint.textContent = role === "pack" ? v.hint : note(P.hints, opts[i]);
        hint.hidden = !hint.textContent;
      });
    }

    // A chip is crossed out when picking it, with the other options as they are, lands on a sold-out variant
    $$("[data-option]", form).forEach(input => {
      const i = +input.dataset.option;
      const alt = find(opts.map((o, j) => (j === i ? input.value : o)));
      input.closest(".chip").classList.toggle("is-out", !alt || !alt.available);
      // Delivery chips show their own price for the chosen size and pack
      if (i === P.shipIndex && alt) {
        const small = $("small", input.closest(".chip"));
        const d = leadFor(input.value);
        const text = [d ? fill(S.days, "days", daysText(d)) : "", money(alt.price)].filter(Boolean).join(" · ");
        if (small) small.textContent = text;
      }
    });

    // Stock line, buttons and the arrival date the cart line carries
    const d = P.pre ? leadFor(P.shipIndex >= 0 ? opts[P.shipIndex] : "") : null;
    let cls = "", text, label = S.add;
    if (P.pre && v.available) {
      cls = " is-pre"; label = S.preorder;
      text = d ? fill(S.preStock, "arrival", arrival(d)) : S.preStockPlain;
    } else if (!v.available) {
      cls = " is-out"; label = S.soldOut; text = S.outOfStock;
    } else if (v.qty !== null && v.qty > 0 && v.qty <= P.lowStock) {
      cls = " is-low"; text = fill(S.lowStock, "quantity", v.qty);
    } else {
      text = S.inStock;
    }
    const stock = $("[data-stock]", form);
    stock.className = "buy__stock" + cls;
    stock.textContent = text;
    setButton($("[data-add]", form), label, !v.available);
    setButton(document.querySelector("[data-sticky-add]"), label, !v.available);
    const arrives = $("[data-arrives]", form);
    if (arrives) arrives.value = d ? arrival(d) : "";

    const pay = $("[data-pay]", form);
    if (pay) pay.hidden = !v.available;
    const notify = $("[data-notify]");
    if (notify) {
      notify.hidden = v.available;
      const tags = $("[data-notify-tags]", notify);
      if (tags) tags.value = `notify,${P.handle},variant-${v.id}`;
    }

    const sticky = document.querySelector("[data-sticky-variant]");
    if (sticky) sticky.textContent = (P.variants.length > 1 ? opts.join(", ") + ", " : "") + money(v.price);

    if (!first) refreshRelated(v);
  }

  form.addEventListener("change", e => {
    const input = e.target.closest("[data-option]");
    if (!input) return;
    const opts = selected();
    // A combination that doesn't exist falls back to the nearest one that keeps the chip just picked
    let v = find(opts);
    if (!v) {
      const i = +input.dataset.option;
      const keep = P.variants.filter(x => x.options[i] === input.value);
      const score = x => x.options.filter((o, j) => o === opts[j]).length + (x.available ? 0.5 : 0);
      v = keep.sort((a, b) => score(b) - score(a))[0];
      if (!v) return;
      $$("[data-option]", form).forEach(r => { r.checked = v.options[+r.dataset.option] === r.value; });
    }
    update(v);
  });

  // ---------- Gallery thumbs ----------
  page.addEventListener("click", e => {
    const t = e.target.closest("[data-thumb]");
    if (t) showMedia(+t.dataset.thumb);
  });

  // ---------- Quantity ----------
  const qty = $("[data-qty]", form);
  form.addEventListener("click", e => {
    const s = e.target.closest("[data-step]");
    if (s && qty) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + +s.dataset.step);
  });
  qty && qty.addEventListener("change", () => { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });

  // ---------- Sticky bar: after the main button scrolls away, hidden again over the footer ----------
  const sticky = document.querySelector("[data-sticky]");
  const add = $("[data-add]", form), footer = document.querySelector(".footer");
  if (sticky && add && "IntersectionObserver" in window) {
    let pastAdd = false, atFooter = false;
    const toggle = () => sticky.classList.toggle("is-visible", pastAdd && !atFooter);
    new IntersectionObserver(([en]) => { pastAdd = !en.isIntersecting && en.boundingClientRect.top < 0; toggle(); }).observe(add);
    if (footer) new IntersectionObserver(([en]) => { atFooter = en.isIntersecting; toggle(); }).observe(footer);
  }

  // The page may come from cache, so the arrival dates and chip states are worked out again here
  update(find(selected()) || P.variants[0], true);
})();
